import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import { isNullOrUndefined, getDecimalLength } from '../../../utils/general'

export default class InputNumberTextField extends PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    title: PropTypes.string,
    fieldName: PropTypes.string,
    fieldValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    required: PropTypes.bool.isRequired,
    error: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    showLabel: PropTypes.bool,
    readOnly: PropTypes.bool,
    maxDecimals: PropTypes.number,
    maxNumber: PropTypes.number
  }

  render() {
    return (
      <div className="group">
        {this.props.showLabel !== false ? (
          <label className={`header ${this.props.error ? 'error' : ''}`} htmlFor={this.props.name}>
            {this.props.name ? this.props.name : null}
            {this.props.required ? ' *' : null}
          </label>
        ) : null}
        <div className="input-wrapper">
          <input
            className={`input-field ${this.props.error ? 'error' : null}`}
            value={!isNullOrUndefined(this.props.fieldValue) ? this.props.fieldValue : ''}
            onChange={this.onChange}
            id={this.props.name}
            type="text"
            title={this.props.title}
            disabled={this.props.readOnly === true}
          />
        </div>
        {this.props.error && <div className="input-error-message">{this.props.error}</div>}
      </div>
    )
  }

  onChange = event => {
    const number = event.target.value.replace(',', '.')
    const isValid = stringIsValidNumber(number)
    const exceedsMaxDecimalLenght = this.props.maxDecimals && getDecimalLength(number) > this.props.maxDecimals
    const exceedsMaxNumber = parseFloat(number) > this.props.maxNumber
    if (exceedsMaxDecimalLenght || !isValid || exceedsMaxNumber) {
      return
    }

    this.props.onChange(number, this.props.fieldName)
  }
}

/**
 * Check if string contains a valid number
 * @param {string} number
 */
function stringIsValidNumber(number) {
  const valueWithDot = number.replace(',', '.')
  const isNumber = !isNaN(parseFloat(valueWithDot)) || valueWithDot === ''

  return isNumber
}
